import useAnalytics from "lib/hooks/use-analytics";

export default function Analytics() {
  useAnalytics();

  return null;
}
